import { manufacturingFetch } from "@/lib/manufacturingClient";
import type { PriceChangeLine, PriceChangeStatus } from "./priceChangeSnapshot";

export type PriceChangeSnapshotSummary = {
  id: string;
  name: string;
  notes: string;
  status: PriceChangeStatus;
  committed_at: string | null;
  updated_at: string;
  line_count: number;
  edit_count: number;
};

export type PriceChangeSnapshotDetail = {
  id: string;
  organization_id: string;
  name: string;
  notes: string;
  status: PriceChangeStatus;
  lines: PriceChangeLine[];
  committed_at: string | null;
  created_at: string;
  updated_at: string;
};

export function listPriceChangeSnapshots() {
  return manufacturingFetch<{ ok: true; snapshots: PriceChangeSnapshotSummary[] }>(
    "/api/mfg/price-changes",
    { method: "GET" },
  );
}

export function getPriceChangeSnapshot(id: string) {
  const q = new URLSearchParams({ id });
  return manufacturingFetch<{ ok: true; snapshot: PriceChangeSnapshotDetail }>(
    `/api/mfg/price-changes/detail?${q.toString()}`,
    { method: "GET" },
  );
}

export function getPriceChangeCatalog() {
  return manufacturingFetch<{ ok: true; lines: PriceChangeLine[] }>("/api/mfg/price-changes/catalog", {
    method: "GET",
  });
}

export function savePriceChangeDraft(body: {
  id?: string;
  name: string;
  notes: string;
  lines: PriceChangeLine[];
}) {
  return manufacturingFetch<{ ok: true; snapshot: PriceChangeSnapshotDetail }>("/api/mfg/price-changes/save", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
}

export function commitPriceChange(id: string) {
  return manufacturingFetch<{ ok: true; snapshot: PriceChangeSnapshotDetail; applied: number }>(
    "/api/mfg/price-changes/commit",
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id }),
    },
  );
}
